import { createSlice } from "@reduxjs/toolkit";

const userPermissionSlice = createSlice({
  name: "userPermission",
  initialState: {
    roleData: null,
    rolePermissions: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setRoleData(state, action) {
      state.roleData = action.payload;
    },
    setRolePermissions(state, action) {
      state.rolePermissions = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    logout(state) {
      // Reset all the state values to their initial state
      state.roleData = null;
      state.rolePermissions = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const { setRoleData, setRolePermissions, setLoading, setError ,logout} =
  userPermissionSlice.actions;

export default userPermissionSlice.reducer;
